import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, Col, Modal, Row } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
// import { deleteUser } from 'src/services';
import { StepIcon } from '../../StepIcon';
import { Svg } from '../../Svg';
import { CreateConsultantFirstStepWithGlobalContext } from './CreateConsultantFirstStep';
import { CreateConsultantSecondStepWithGlobalContext } from './CreateConsultantSecondStep';
import { CreateConsultantThirdStepWithGlobalContext } from './CreateConsultantThirdStep';

interface IProjectModalProps {
  isOpen: boolean;
  toggleCreateConsultantModal: () => void;
  toggleLoginModal: () => void;
  toggleSignupConfirmationModal: () => void;
}

const CreateConsultantModal: React.SFC<
  IProjectModalProps & IGlobalContextProps & RouteComponentProps
> = ({
  context,
  isOpen,
  toggleCreateConsultantModal,
  toggleLoginModal,
  toggleSignupConfirmationModal,
}) => {
  const { user } = context;
  const [state, setState] = React.useState({
    stepNumber: 1,
  });

  const handleLoginClick = () => {
    toggleLoginModal();
  };

  const changeStep = (stepNumber: number) => {
    setState({ ...state, stepNumber });
  };

  const toggleModalWithDeleteUser = () => {
    if (context.isCreating) {
      // deleteUser();
      context.updateUser(true);
      context.toggleIsCreating();
      changeStep(1);
    }
    closeModal();
  };

  const closeModal = () => {
    setState({
      stepNumber: 1,
    });
    toggleCreateConsultantModal();
  };

  return (
    <Modal  className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='secondary'
        width={280}
        height={210}
        opacity={0.2}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg
          fill='dark'
          src='close'
          width={16}
          onClick={toggleModalWithDeleteUser}
        />
      </div>
      <div
        className='d-flex justify-content-between align-items-center pl-5 pr-5'
        style={{ zIndex: 1 }}
      >
        <h3>
          Devenez
          <br />
          consultant
        </h3>
        {!user && (
          <div className='d-flex flex-column'>
            <span className='text-primary'>J'ai déjà un compte</span>
            <Button
              className='btn-sm text-uppercase text-white bg-primary border-0 mt-2'
              onClick={handleLoginClick}
            >
              Connexion
            </Button>
          </div>
        )}
      </div>
      <Row className='pl-5 pr-5 mt-4'>
        <Col xs='6' />
        {[1, 2, 3].map((stepNumber: number, key: number) => (
          <StepIcon
            key={key}
            activeFill='primary'
            fill='secondary'
            isActive={stepNumber === state.stepNumber}
            opacity={stepNumber <= state.stepNumber ? 1 : 0.5}
            src='step-bulle-popin'
            stepNumber={stepNumber}
          />
        ))}
      </Row>
      {state.stepNumber === 1 && (
        <CreateConsultantFirstStepWithGlobalContext
          changeStep={changeStep}
          toggleCreateConsultantModal={closeModal}
        />
      )}
      {state.stepNumber === 2 && (
        <CreateConsultantSecondStepWithGlobalContext
          changeStep={changeStep}
          toggleCreateConsultantModal={closeModal}
        />
      )}
      {state.stepNumber === 3 && (
        <CreateConsultantThirdStepWithGlobalContext
          changeStep={changeStep}
          toggleCreateConsultantModal={closeModal}
          toggleSignupConfirmationModal={toggleSignupConfirmationModal}
        />
      )}
    </Modal>
  );
};

export const CreateConsultantModalWithGlobalContext = withGlobalContext(
  withRouter(CreateConsultantModal)
);



// WEBPACK FOOTER //
// ./src/components/shared/Modals/CreateConsultantModal/CreateConsultantModal.tsx